import { gql } from "@apollo/client";

const GET_REPORT_DATA = gql`
  query getReportData($input: GetReportDataInput) {
    getReportData(input: $input) {
      data {
        _id
        orderNumber
        lineItemId
        title
        vendor
        quantity
        markup
        sellerCommission
        createdAt
        orderAcceptanceDate
        orderReadyToCollectDate
        orderPickupTime
        orderDeliveryDate
        fulfillmentStatus
        shipping
        tax
        sku
        orderStatus
        vendorPaymentStatus
        vendorAmount
        vendorPaidDate
        price
        productCost
        discount
        returns
        productType
        customerProductPrice
        totalSalesPrice
        grossSales
        grossProfit
        trackingNumber
        paymentGateway
        vendorId
        dueDate
        commissionTax
        consignmentShipping
        priceAfterVendorDiscount
        paymentId
        voucherDetails {
          totalDiscount
          operatorDiscount
          xhawiVendorDiscount
        }
        commissionSetting {
          rate
          type
        }
        commissionTaxSetting {
          rate
          type
        }
      }
      error
      status
    }
  }
`;

export default GET_REPORT_DATA;
